export enum AccountStatus {
  FirstTimeUser = 1,
  Active = 2,
  VerificationRequired = 4,
}
